module.exports = __webpack_public_path__ + "img/title-bg.8baa03f5.png";